import { RootState, RouterState } from '@k2/common/routing/state';
import { Params } from '@angular/router';

export function getRouterState(state: RootState): RouterState {
  return state.routerReducer?.state;
}

export function getCurrentUrl(state: RootState): string {
  return getRouterState(state)?.url;
}

export function getRouteParams(state: RootState): Params {
  return getRouterState(state)?.params;
}

export function getQueryParams(state: RootState): Params {
  return getRouterState(state)?.queryParams;
}
